/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import rootLBIL from '../_helpers/lbilRoots';

let lbilSUserInfoApiUrl = rootLBIL.lbilSUserInfoApiUrl.link;
let loginLBILurl = rootLBIL.lbilAdminLoginApiUrl.link;
let loginotpLBILurl = rootLBIL.lbilAdminLoginVerfiyApiUrl.link;
let userLogoutLBILApiUrl = rootLBIL.lbilAdminLogoutApiUrl.link;
let doctorConsultApiUrl = rootLBIL.doctorConsultApiUrl.link;
let doctorConsultReqApiUrl = rootLBIL.doctorConsultReqApiUrl.link;
let doctorConsultReqLisApiUrl = rootLBIL.doctorConsultReqLisApiUrl.link;
let lbilAllUsersListApiUrl = rootLBIL.lbilAllUsersListApiUrl.link;

export default {
  state: {
    token: localStorage.getItem('token'),
    status: '',
    lbilSuUserDetailState:''
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
    lbilSuUserDetailMutations(state, value) {
      Vue.set(state, 'lbilSuUserDetailState', value);
    },
  },
  actions: {
    lbilAllUsersListAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(lbilAllUsersListApiUrl).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    doctorConsultReqLisAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(doctorConsultReqLisApiUrl).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Get LBIL User Info Action Function
    getLBILSUserInfoApiFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilSUserInfoApiUrl, payload).then(response => {
            context.commit('lbilSuUserDetailMutations', response.data);
            resolve(response);
            }).catch(err => {
            reject(err);
            })
        })
    },
    logoutFromApiLBILAction(context) {
      return new Promise((resolve, reject) => {
        let payload = {
          type: "web"
        }
        axios.post(userLogoutLBILApiUrl)
          .then((response) => {
            context.commit('authLogout');
            localStorage.removeItem('token');
            localStorage.removeItem('LoginedUserID');
            localStorage.removeItem('userAgreementState');
            delete axios.defaults.headers.common['Authorization'];
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    doctorReqApprovalAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.patch(doctorConsultReqApiUrl + payload.data.id + '/', payload.data.data).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    reqDoctorListAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(doctorConsultReqApiUrl).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    lbilDoctorsListAction(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(doctorConsultApiUrl + '?is_active=true').then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    checkLBILLoginTypeAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginLBILurl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginWithOtpLBILAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginotpLBILurl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Token ' + localStorage.getItem('token')
      }
    },
  },
  getters: {
    // isAuthenticated: state => !!state.token && !!localStorage.getItem('LoginedUserID'),
    // authStatus: state => state.status
    lbilSuUserDetailGetters: state => state.lbilSuUserDetailState
  }
}